var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TrackList',{attrs:{"tracks":_vm.tracks},scopedSlots:_vm._u([{key:"context-menu",fn:function(ref){
var index = ref.index;
return [_c('b-dropdown-item-button',{on:{"click":function($event){return _vm.remove(index)}}},[_vm._v(" Remove ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }